// Frontend-specific app settings

const baseUrl = "https://d135lw6vh1h84k.cloudfront.net/peerteach.us/";

const Settings = {
    fullAudio: baseUrl + "full.mp3",
    halfAudio: baseUrl + "half.mp3",
    neutralAudio: baseUrl + "neutral.mp3",
    lossAudio: baseUrl + "loss.mp3",
    tickAudio: baseUrl + "tick.mp3",
    videoEndMargin: 10,
    logLevel: 0
}

export {Settings};



// WEBPACK FOOTER //
// ./src/settings.js